import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=1f00c80a"
import script from "./admin-layout.ts?vue&type=script&lang=js&external"
export * from "./admin-layout.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports